const getOnTheFlyTransformURL = (url, width) => url.replace("upload/", `upload/w_${width}/`)

export default getOnTheFlyTransformURL